import { Mapper } from "../../../../base/utils/mapper";
import { TypeStateTestFisicalModel } from "../../../../domain/models/consult/type-state-test-medical.model";
import { TypeStateTestFisicalEntity } from "../entities/type-state-test-medical.entity";

export class TypeStateTestFisicalImplementationRepositoryMapper extends Mapper<TypeStateTestFisicalEntity, TypeStateTestFisicalModel> {
    mapFrom(param: TypeStateTestFisicalEntity): TypeStateTestFisicalModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeStateTestFisicalModel): TypeStateTestFisicalEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}